import { render, staticRenderFns } from "./higg-form.vue?vue&type=template&id=1863c346&"
import script from "./higg-form.vue?vue&type=script&lang=js&"
export * from "./higg-form.vue?vue&type=script&lang=js&"
import style0 from "./higg-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports